import styled from 'styled-components';

import { spacing } from '../../../atoms/spacing';
import { richTextStyles } from '../../../atoms/typography';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[24]};
  ${richTextStyles}
`;

export const Asset = styled.div`
  width: 100%;
  height: auto;
  margin: 40px auto;
  aspect-ratio: 16/9;

  &:first-child {
    margin-top: 0px;
  }

  img,
  .gatsby-image img {
    object-fit: contain !important;
    aspect-ratio: 16/9;
  }
`;

export const CardDeckWrapper = styled.div`
  width: 100%;
  height: auto;
  .card-deck-section {
    width: 100%;
    height: auto;
    padding: ${spacing[24]} ${spacing[0]};
    margin: ${spacing[0]};
  }
  .card-deck-wrapper {
    width: 100%;
    max-width: 100%;
    height: auto;
    padding: 0px;
    margin: 0px;
  }
  .card-deck-heading,
  .cardDeck-subhead {
    width: 100%;
    max-width: 100%;
    height: auto;
    margin: 0px;
    text-align: left;
  }
  .card-deck-grid {
    grid-template-columns: repeat(2, 1fr);
    @media (max-width: 768px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }
`;

export const ConversionWrapper = styled.div`
  margin-top: ${spacing[48]};
  @media (max-width: 991px) {
    display: none;
  }
`;

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  gap: ${spacing[12]};
`;
